import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/LocationOverviewDashboard/components/Tyres/Tyres.scss";

import type { LocationDetailFormPayload } from "modules/LocationOverviewDashboard/hooks";

const FormHelper = createFormHelper<LocationDetailFormPayload>();

type TyresProps = {
  tabId: string;
};

type ThresholdColumn = {
  label: string;
  icon: string;
  advice: "all_season_a_threshold" | "summer_a_threshold" | "winter_a_threshold" | "truck_tyre_a_threshold";
  critical: "all_season_n_threshold" | "summer_n_threshold" | "winter_n_threshold" | "truck_tyre_n_threshold";
};

const THRESHOLD_COLUMNS: ThresholdColumn[] = [
  { label: "v8_all_season", icon: "road", advice: "all_season_a_threshold", critical: "all_season_n_threshold" },
  { label: "v8_summer_tyres", icon: "sun", advice: "summer_a_threshold", critical: "summer_n_threshold" },
  { label: "v8_winter_tyres", icon: "snowflake", advice: "winter_a_threshold", critical: "winter_n_threshold" },
  { label: "v8_truck_tyres", icon: "truck", advice: "truck_tyre_a_threshold", critical: "truck_tyre_n_threshold" }
];

export const Tyres = ({ tabId }: TyresProps) => {
  const { t } = useTranslation();

  const { watch } = FormHelper.useFormContext();

  return (
    <Element name={tabId} className="location-overview-section">
      <div className="section-title">
        <div>
          <Icon className="tire" />
        </div>
        <span className="section-title-text">{t("v8_tyres", "Tyres")}</span>
      </div>

      <Form.Group widths="equal">
        {THRESHOLD_COLUMNS.map(column => {
          const hasError = watch(column.critical) > watch(column.advice);

          return (
            <Form.Field key={column.advice}>
              <div className="tyre-column-title">
                <div>
                  <Icon className={column.icon} />
                </div>
                {t(column.label)}
              </div>
              <label>{t("v8_all_season_advice_threshold", "All season advice threshold")}</label>
              <FormHelper.Field.Input name={column.advice} inputProps={{ type: "number", step: 0.1, min: 0, className: hasError ? "threshold-error" : "" }} />
              <label className="critical-threshold-label">{t("v8_summer_critical_threshold", "Summer critical threshold")}</label>
              <FormHelper.Field.Input name={column.critical} inputProps={{ type: "number", step: 0.1, min: 0, className: hasError ? "threshold-error" : "" }} />
            </Form.Field>
          );
        })}
      </Form.Group>
      <Form.Group>
        <Form.Field width={16}>
          <FormHelper.Field.Checkbox name="is_tyre_status_always_visible_on_wo" label={t("v8_show_tyre_status_always", "Show tyre status always")} />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
